<template>
    <div :class="shown && !transitioning ? 'hello-container show pt-4' : 'hello-container pt-4'" @click="sendClick($event)">
        <good :shown="show === 0 && !transitioning" :bold="texts[0].bold" :normal="texts[0].normal" />
        <good :shown="show === 1 && !transitioning" :bold="texts[1].bold" :normal="texts[1].normal" />
        <recycle :shown="[2,3,4,5].includes(show) && !transitioning" :type="texts[show] ? texts[show].type : texts[2].type" :bold="texts[show] ? texts[show].bold : texts[2].bold" />
        <wingo :shown="show === 6 && !transitioning" />
    </div>
</template>

<script>
import Good from '@/components/commercials/Good';
import Recycle from '@/components/commercials/Recycle';
import Wingo from '@/components/commercials/Wingo';
import Vue from 'vue';
export default {
  components: {
    Good,
    Recycle,
    Wingo
  },
  props: [
      "shown"
  ],
  data () {
    return {
      show: 6,
      texts: {
        0: {
          bold: this.$t('commercials_one_bold'),
          normal: this.$t('commercials_one_normal'),
        },
        1: {
          bold: this.$t('commercials_two_bold'),
          normal: this.$t('commercials_two_normal'),
        },
        2: {
          bold: this.$t('commercials_three_bold'),
          type: 'pet',
        },
        3: {
          bold: this.$t('commercials_four_bold'),
          type: 'can',
        },
        4: {
          bold: this.$t('commercials_five_bold'),
          type: 'tetrapack',
        },
        5: {
          bold: this.$t('commercials_six_bold'),
          type: 'battery',
        },
      },
      timer: null,
      transitioning: false,//true
    }
  },
  mounted () {
    this.startCarousel();
  },
  created () {
  },
  computed: {
  },
  methods: {
    sendClick(e) {
      e.preventDefault();
      this.$emit('screenClick');
    },
    startCarousel() {
      // if (this.show !== 0) {
      //   Vue.set(this, 'show', 0);
      // }
      // let that = this;
      // Vue.set(this, 'transitioning', true);
      // setTimeout(function (e) {
      //   Vue.set(that, 'transitioning', false);
      // }, 250)
      // this.timer = setTimeout(function (e) {
      //   that.nextSlide();
      // }, 3500)
    },

    nextSlide() {return;
      let that = this;
      let last = this.show;
      Vue.set(this, 'show', last === 6 ? 0 : (last + 1));
      if (last < 2 && last > 4) {
        Vue.set(this, 'transitioning', true);
        setTimeout(function (e) {
          Vue.set(that, 'transitioning', false);
        }, 250)
      }
      this.timer = setTimeout(function (e) {
        if (that.timer && that.shown) {
          that.nextSlide();
        }
      }, 3500)
    }
  },
  watch: {
    shown: function (val, oldVal) {
      if (val) {
        this.startCarousel();
      } else if (oldVal) {
        Vue.set(this, 'transitioning', false);
        clearTimeout(this.timer);
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>